<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-lg-2">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Employee</h4>
                  <v-select
                    :options="employee"
                    label="name"
                    v-model="searchEmployee"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-2">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Customer</h4>
                  <v-select
                    :options="customers"
                    label="customer"
                    v-model="searchCustomer"
                    @input="getJobs()"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-2">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Product</h4>
                  <v-select
                    :options="productNames"
                    label="products"
                    v-model="searchProduct"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-2">
                <div class="mt-4 mt-lg-0">
                  <h4 class="card-title">Job #</h4>
                  <v-select
                    :options="jobs"
                    item-text="label"
                    item-value="value"  
                    v-model="searchJobNum"
                  ></v-select>
                </div>
              </div>
              <div class="col-lg-2">
                <h4 class="card-title">Start Date</h4>
                <date-picker
                  v-model="searchStartDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
              <div class="col-lg-2">
                <h4 class="card-title">End Date</h4>
                <date-picker
                  v-model="searchEndDate"
                  :first-day-of-week="1"
                  lang="en"
                ></date-picker>
              </div>
            </div>

            <!-- end row -->
            <div class="form-group row mt-4 d-flex justify-content-end align-items-end mr-2">
              <label class="mb-0 mr-2">Time Approval Status: </label>
              <div>
                <div class="d-flex" style="gap: 1rem;">
                  <b-form-radio
                    v-for="(type, typeIndex) in timeApprovalStatusFilters"
                    :key="typeIndex"
                    v-model="selectedTimeApprovalFilter"
                    :name="type.label"
                    :value="type.value"
                  >
                    {{ type.label }}
                  </b-form-radio>
                </div>
              </div>
            </div>

            <div class="row mt-4 d-flex flex-row-reverse align-items-center">
              <div class="">
                <div class="]">
                  <b-button
                    id="btn_search"
                    variant="primary"
                    :disabled="reportLoading"
                    v-on:click="generateReport()"
                    >Generate</b-button
                  >
                </div>
              </div>
              <div class="mr-4">
                <div class="">
                  <CostEarningsReportPDF
                    :tableData="
                      allEmployeesIncluded ? allEmployeesTableData : tableData
                    "
                    :reportTotals="
                      allEmployeesIncluded
                        ? allEmployeesReportTotals
                        : reportTotals
                    "
                    :productTableData="productsTableData"
                    :productReportTotals="productReportTotals"
                    :procurementTableData="procurementTableData"
                    :procurementReportTotals="procurementReportTotals"
                    :searchCustomer="searchCustomer"
                    :searchProduct="searchProduct"
                    :searchJobNum="searchJobNum.value !== null ? searchJobNum.value : null"
                    :searchStartDate="searchStartDate"
                    :searchEndDate="searchEndDate"
                    :searchEmployee="
                      searchEmployee != null ? searchEmployee.name : ''
                    "
                    :showProducts="showProducts"
                    :showProcurements="showProcurements"
                  ></CostEarningsReportPDF>
                </div>
              </div>
              <div class="mr-4">
                <div class="">
                  <b-button
                    v-b-modal.export-modal
                    variant="primary"
                    class="btn btn-label btn-primary"
                    :disabled="tableData.length === 0 && productsTableData.length === 0 && procurementTableData.length === 0"
                  >
                    <i class="bx bx-export label-icon"></i>Export to Excel
                  </b-button>
                </div>
              </div>
              <div class="">
                <div>
                  <div class="form-group">
                    <switches
                      text-enabled="Products Shown"
                      text-disabled="Products Hidden"
                      v-model="showProducts"
                      type-bold="false"
                      color="primary"
                      class="ml-3 mb-0 mr-4"
                    ></switches>
                  </div>
                </div>
              </div>
              <div class="">
                <div>
                  <div class="form-group">
                    <switches
                      text-enabled="Procurements Shown"
                      text-disabled="Procurements Hidden"
                      v-model="showProcurements"
                      type-bold="false"
                      color="primary"
                      class="ml-3 mb-0"
                    ></switches>
                  </div>
                </div>
              </div>
              <div class="">
                <div>
                  <div class="form-group">
                    <switches
                      text-enabled="All Employees"
                      text-disabled="Active Employees"
                      v-model="allEmployeesIncluded"
                      type-bold="false"
                      color="primary"
                      class="ml-1 mb-0"
                    ></switches>
                  </div>
                </div>
              </div>
              <div class="row mt-3 float-left">
                <div class="col-3">
                  <h5
                    v-if="searchEmployee !== null || searchProduct !== null"
                    class="mt-3"
                  >
                    <b-badge variant="warning"
                      >Procurement data is not shown when Employee or Product is
                      selected</b-badge
                    >
                  </h5>
                </div>
              </div>
            </div>
            <!-- en row -->
          </div>
        </div>
        <!-- end card -->
        <!-- Totals -->
        <div class="row" v-if="allEmployeesIncluded">
          <div
            v-for="total of allEmployeesReportTotals"
            :key="total.index"
            class="col-md-3"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.dollar ? `$${total.value}` : total.value"
            />
          </div>
        </div>
        <div class="row" v-else>
          <div
            v-for="total of reportTotals"
            :key="total.index"
            class="col-md-3"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.dollar ? `$${total.value}` : total.value"
            />
          </div>
        </div>
        <!-- /Totals -->
        <!-- Product Totals -->
        <div class="row" v-if="showProducts">
          <div
            v-for="total of productReportTotals"
            :key="total.index"
            class="col-md-3"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.dollar ? `$${total.value}` : total.value"
            />
          </div>
        </div>
        <!-- /Product Totals -->
        <!-- Procurement Totals -->
        <div class="row" v-if="showProcurements">
          <div
            v-for="total of procurementReportTotals"
            :key="total.index"
            class="col-md-3"
          >
            <Stat
              :icon="total.icon"
              :title="total.title"
              :value="total.dollar ? `$${total.value}` : total.value"
              :color="total.color"
            />
          </div>
        </div>
        <!-- /Product Totals -->
        <!-- Table -->
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Times</h4>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                :items="
                  allEmployeesIncluded ? allEmployeesTableData : tableData
                "
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-compare="tableSort"
                :filter="filter"
                :filter-included-fields="filterOn"
                primary-key="id"
              >
                <template v-slot:cell(jobActions)="data">
                  <b-dropdown size="sm" variant="primary">
                    <template v-slot:button-content>
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item @click="updateJobCompleteStatus(data.item.JobDocID, data.item.JobCompletedStatus)">
                      <i class="bx mr-2 tableIcons" :class="!data.item.JobCompletedStatus ? 'bx-check' : 'bx-x'"></i>
                      {{!data.item.JobCompletedStatus ? 'Mark Job as Complete' : 'Mark Job as Incomplete'}}
                    </b-dropdown-item>
                    <b-dropdown-item @click="goToJob(data.item.Job)">
                      <i class="bx mr-2 tableIcons bx-log-in-circle"></i>
                      Go to Job
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
                <template v-slot:cell(approved)="data">
                  <div
                    :id="`hoursApproved-${data.item.id}`"
                    style="display: inline-block"
                  >
                    <b-form-checkbox v-model="data.item.approved" @change="(newValue) => approveTime(newValue, data.item.id)">
                    </b-form-checkbox>
                  </div>
                  <b-tooltip
                    :target="`hoursApproved-${data.item.id}`"
                    triggers="hover"
                    v-if="data.item.approved && data.item.approvedBy"
                  >
                    {{
                      `Approved by ${
                        data.item.approvedBy.name
                      } on ${data.item.approvedTime
                        .toString()
                        .substring(0, 15)} at ${data.item.approvedTime
                        .toString()
                        .substring(16, 21)}`
                    }}
                  </b-tooltip>
                </template>
                <template v-slot:cell(Job)="data">
                  <router-link
                    :to="{
                    path: '/production/jobs/jobDetails/' + getJobNumFromString(data.item.Job)}">
                    <span :class="data.item.JobCompletedStatus ? 'text-success' : ''">{{data.item.Job}}</span>
                  </router-link>
                </template>
                <template v-slot:cell(billable)="data">
                  <b-badge :variant="data.value ? 'success' : 'danger'">{{
                    data.value ? 'Yes' : 'No'
                  }}</b-badge>
                </template>
                <template v-slot:cell(type)="data">
                  <b-badge :variant="data.value === 'ot'
                  ? 'danger'
                  : data.value === 'tt'
                  ? 'info'
                  : 'success'">{{
                    data.value === 'ot'
                      ? 'Overtime'
                      : data.value === 'tt'
                      ? 'Travel'
                      : 'Regular'
                  }}</b-badge>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-right"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Table -->
        <!-- Billable Products Table -->
        <BillableProductsTable
          :tableData="productsTableData"
          :allowApprovalProduct="true"
          v-if="showProducts"
          @approve-change="handleApprovalChange"
        >
        </BillableProductsTable>
        <!-- /Billable Products Table -->
        <!-- Procurements Table -->
        <ProcurementReportTable
          v-if="showProcurements"
          ref="procurementTable"
          :tableData="procurementTableData"
          :totalQuotedAmount="totalQuotedAmount"
          :totalReceivedAmount="totalReceivedAmount"
        ></ProcurementReportTable>
        <!-- /Procurements Table -->

        <!-- Export Modal -->
        <ExportToExcelModal
          :tableData="allEmployeesIncluded ? allEmployeesTableData : tableData"
          :productsTableData="productsTableData"
          :procurementTableData="procurementTableData"
          :allEmployees="allEmployees"
          :searchCustomer="searchCustomer"
          :searchProduct="searchProduct"
          :searchJobNum="searchJobNum.value !== null ? searchJobNum.value : null"
          :searchStartDate="searchStartDate"
          :searchEndDate="searchEndDate"
          :searchEmployee="searchEmployee != null ? searchEmployee.name : ''"
        />
        <!-- /Export Modal -->

        <!-- Chart -->
        <div class="row">
          <div
            v-bind:class="
              chart1Visible == false && chart2Visible == false
                ? 'col-12'
                : 'col-6'
            "
          >
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Hours Worked by Day</h4>
                <!-- Column Charts -->
                <apexchart
                  class="apex-charts"
                  height="350"
                  type="area"
                  dir="ltr"
                  id="hoursByDays"
                  :options="
                    allEmployeesIncluded
                      ? allEmployeesHoursByDays.chartOptions
                      : hoursByDays.chartOptions
                  "
                  :series="
                    allEmployeesIncluded
                      ? allEmployeesHoursByDays.series
                      : hoursByDays.series
                  "
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="chart1Visible">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Employee's Hours by Job</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="
                    allEmployeesIncluded
                      ? allEmployeesHoursByJob.chartOptions
                      : hoursByJob.chartOptions
                  "
                  :series="
                    allEmployeesIncluded
                      ? allEmployeesHoursByJob.series
                      : hoursByJob.series
                  "
                  :labels="
                    allEmployeesIncluded
                      ? allEmployeesHoursByJob.labels
                      : hoursByJob.labels
                  "
                ></apexchart>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="chart2Visible">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title mb-4">Employee's Hours by Customer</h4>
                <apexchart
                  width="500"
                  height="350"
                  type="donut"
                  :options="
                    allEmployeesIncluded
                      ? allEmployeesHoursByCustomer.chartOptions
                      : hoursByCustomer.chartOptions
                  "
                  :series="
                    allEmployeesIncluded
                      ? allEmployeesHoursByCustomer.series
                      : hoursByCustomer.series
                  "
                  :labels="
                    allEmployeesIncluded
                      ? allEmployeesHoursByCustomer.labels
                      : hoursByCustomer.labels
                  "
                  class="reportsDonutChart"
                ></apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Chart -->
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Vue from 'vue';
import Layout from '../../../layouts/main';
import PageHeader from '@/components/page-header';
import appConfig from '@/app.config';
import DatePicker from 'vue2-datepicker';
import routes from '../../../routes.js';
import Stat from '@/components/widgets/stat';
import CostEarningsReportPDF from '../components/reports/CostEarningsReportPDF.vue';
import BillableProductsTable from '../components/reports/billableProductsReportTable.vue';
import ProcurementReportTable from '../components/reports/procurementReportTable.vue';
import Switches from 'vue-switches';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(VueToast);
import Swal from 'sweetalert2';
import lodash from 'lodash';
import firebase from 'firebase';
import {
  getCustomers,
  getJobsFromCustomer,
  getAllEmployees,
  getProducts,
} from '../helper/dbHelpers.js';
import moment from 'moment';
import { tableSort } from '../helper/helpers.js';
import ExportToExcelModal from '../components/reports/CostEarningsExcelExportModal.vue';

export default {
  page: {
    title: 'Cost Vs Earnings Report',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    Stat,
    CostEarningsReportPDF,
    BillableProductsTable,
    Switches,
    ProcurementReportTable,
    ExportToExcelModal,
  },
  data() {
    return {
      title: 'Cost Vs Earnings Report',
      name: 'costEarnings',
      items: [
        {
          text: 'home',
          href: '/',
        },
        {
          text: 'cost vs earnings report',
          href: '/production/reports/costEarnings',
          active: true,
        },
      ],
      routes: routes,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'Date',
      sortDesc: false,
      fields: [
        { key: 'jobActions', sortable: false },
        { key: 'approved', sortable: true },
        { key: 'Employee', sortable: true },
        { key: 'Date', sortable: true },
        { key: 'Customer', sortable: true },
        { key: 'Job', sortable: true },
        { key: 'Description', sortable: true, class: 'jobDescription' },
        { key: 'Billable', sortable: true, class: 'billable' },
        { key: 'Hours', sortable: true },
        { key: 'Type', sortable: true },
        { key: 'Rate', label: 'Billable Rate', sortable: true },
        { key: 'PayrollRate', sortable: true },
      ],
      customers: [],
      employee: [],
      allEmployees: [],
      allEmployeesIncluded: true,
      products: [],
      productNames: [],
      jobs: [],
      searchCustomer: null,
      searchProduct: null,
      searchEmployee: null,
      searchJobNum: { label: null, value: null },
      searchStartDate: null,
      searchEndDate: null,
      selectedEmployee: null,
      tableData: [],
      allEmployeesTableData: [],
      productsTableData: [],
      procurementTableData: [],
      chart1Visible: true,
      chart2Visible: true,
      reportLoading: false,
      reportTotals: [
        {
          icon: 'bx bx-timer',
          title: 'Hours Worked',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Days Worked',
          value: '0',
        },
        {
          icon: 'bx bx-abacus',
          title: 'Regular Hours',
          value: '0',
        },
        {
          icon: 'bx bx-health',
          title: 'Overtime Hours',
          value: '0',
        },
        {
          icon: 'bx bxs-truck',
          title: 'Travel Hours',
          value: '0',
        },
        {
          icon: 'bx bxs-star',
          title: 'Total Labour Revenue',
          value: '0',
          dollar: true,
        },
        {
          icon: 'bx bxs-spreadsheet',
          title: 'Total Payroll Paid',
          value: '0',
          dollar: true,
        },
      ],
      allEmployeesReportTotals: [
        {
          icon: 'bx bx-timer',
          title: 'Hours Worked',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Days Worked',
          value: '0',
        },
        {
          icon: 'bx bx-abacus',
          title: 'Regular Hours',
          value: '0',
        },
        {
          icon: 'bx bx-health',
          title: 'Overtime Hours',
          value: '0',
        },
        {
          icon: 'bx bxs-truck',
          title: 'Travel Hours',
          value: '0',
        },
        {
          icon: 'bx bxs-star',
          title: 'Total Labour Revenue',
          value: '0',
          dollar: true,
        },
        {
          icon: 'bx bxs-spreadsheet',
          title: 'Total Payroll Paid',
          value: '0',
          dollar: true,
        },
      ],
      productReportTotals: [
        {
          icon: 'bx bxs-purchase-tag-alt',
          title: 'Amount of Products Sold',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Amount of Days Products Sold',
          value: '0',
        },
        {
          icon: 'bx bx-stats',
          title: 'Total Product Revenue',
          value: '0',
          dollar: true,
        },
        {
          icon: 'bx bxs-chart',
          title: 'Total Paid for Products',
          value: '0',
          dollar: true,
        },
      ],
      procurementReportTotals: [
        {
          icon: 'bx bxs-purchase-tag-alt',
          title: 'Amount of Procurements',
          value: '0',
        },
        {
          icon: 'bx bx-calendar',
          title: 'Total Procurement Expense',
          value: '0',
          dollar: true,
        },
        {
          icon: 'bx bx-stats',
          title: 'Total Procurement Revenue',
          value: '0',
          dollar: true,
        },
        {
          icon: 'bx bxs-chart',
          title: 'Total Procurement Profit',
          value: '0',
          dollar: true,
          color: 'green',
        },
      ],
      hoursByDays: {
        series: [
          {
            name: 'Hours Worked',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#556ee6'],
          },
          colors: ['#556ee6', '#556ee6', '#f46a6a'],
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'hours',
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 0,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' hours worked';
              },
            },
          },
        },
      },
      hoursByJob: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      hoursByCustomer: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      allEmployeesHoursByDays: {
        series: [
          {
            name: 'Hours Worked',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#556ee6'],
          },
          colors: ['#556ee6', '#556ee6', '#f46a6a'],
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'hours',
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 0,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' hours worked';
              },
            },
          },
        },
      },
      allEmployeesHoursByJob: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      allEmployeesHoursByCustomer: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      productsByDays: {
        series: [
          {
            name: 'Products Sold',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: '45%',
              endingShape: 'rounded',
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['#556ee6'],
          },
          colors: ['#556ee6', '#556ee6', '#f46a6a'],
          xaxis: {
            categories: [],
          },
          yaxis: {
            title: {
              text: 'quantity',
            },
          },
          grid: {
            borderColor: '#f1f1f1',
          },
          fill: {
            opacity: 0,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return val + ' products sold';
              },
            },
          },
        },
      },
      productsByJob: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      productsByCustomer: {
        series: [0],
        chartOptions: {
          chart: {
            type: 'donut',
          },
          dataLabels: {
            enabled: false,
          },
          labels: [],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  show: false,
                },
              },
            },
          ],
          legend: {
            position: 'right',
            offsetY: 0,
            height: 200,
          },
        },
      },
      showProducts: false,
      showProcurements: false,
      totalQuotedAmount: 0,
      totalReceivedAmount: 0,
      totalProcurementRevenue: 0,
      currentUser: this.$store.state.custom.currentUserData,
      altTableData: [],
      timeApprovalStatusFilters: [
        { label: 'All', value: 'all' },
        { label: 'Only Approved', value: 'approved' },
        { label: 'Only Unapproved', value: 'unapproved' }
      ],
      selectedTimeApprovalFilter: 'all'
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.allEmployeesIncluded
        ? this.allEmployeesTableData.length
        : this.tableData.length;
    },
  },
  methods: {
    generateReport: async function () {
            // Validate search
      //construct the query string.
      try {
        this.reportLoading = true;
        //in order the chart to auto render, we need to set the array, not just push data to it.
        let hoursWorkedData = [{ name: 'Hours Worked', data: [] }];
        let hoursWorkedDays = { categories: [] };
        let hoursWorkedJob = [];
        let hoursWorkedJobData = [];
        let hoursWorkedCustomer = [];
        let hoursWorkedCustomerData = [];

        let allEmployeesHoursWorkedData = [{ name: 'Hours Worked', data: [] }];
        let allEmployeesHoursWorkedDays = { categories: [] };
        let allEmployeesHoursWorkedJob = [];
        let allEmployeesHoursWorkedJobData = [];
        let allEmployeesHoursWorkedCustomer = [];
        let allEmployeesHoursWorkedCustomerData = [];

        let productsData = [{ name: 'Products Sold', data: [] }];
        let productsDays = { categories: [] };
        let productsJob = [];
        let productsJobData = [];
        let productsCustomer = [];
        let productsCustomerData = [];

        this.reportTotals[0].value = '0';
        this.reportTotals[1].value = '0';
        this.reportTotals[2].value = '0';
        this.reportTotals[3].value = '0';
        this.reportTotals[4].value = '0';
        this.reportTotals[5].value = '0';
        this.reportTotals[6].value = '0';

        this.allEmployeesReportTotals[0].value = '0';
        this.allEmployeesReportTotals[1].value = '0';
        this.allEmployeesReportTotals[2].value = '0';
        this.allEmployeesReportTotals[3].value = '0';
        this.allEmployeesReportTotals[4].value = '0';
        this.allEmployeesReportTotals[5].value = '0';
        this.allEmployeesReportTotals[6].value = '0';

        this.productReportTotals[0].value = '0';
        this.productReportTotals[1].value = '0';
        this.productReportTotals[2].value = '0';
        this.productReportTotals[3].value = '0';

        this.procurementReportTotals[0].value = '0';
        this.procurementReportTotals[1].value = '0';
        this.procurementReportTotals[2].value = '0';
        this.procurementReportTotals[3].value = '0';

        this.tableData = [];
        this.allEmployeesTableData = [];
        this.productsTableData = [];
        this.procurementTableData = [];

        this.totalQuotedAmount = 0;
        this.totalReceivedAmount = 0;
        this.totalProcurementRevenue = 0;

        let query = firebase
          .firestore()
          .collection('times')
          .where('org', '==', sessionStorage.getItem('org'));

        let productsQuery = firebase
          .firestore()
          .collection('billableProducts')
          .where('org', '==', sessionStorage.getItem('org'));

        let procurementQuery = firebase
          .firestore()
          .collection('procurements')
          .where('org', '==', sessionStorage.getItem('org'));
        //create the query string to only search times and products and procurements for a specified employee if there is one selected.
        if (this.searchEmployee != null && this.searchEmployee != '') {
          query = query.where('user', '==', this.searchEmployee.uid);
          productsQuery = productsQuery.where(
            'user.uid',
            '==',
            this.searchEmployee.uid
          );
        }
        if (this.searchCustomer != null && this.searchCustomer != '') {
          query = query.where(
            'customer',
            '==',
            this.searchCustomer.toLowerCase()
          );
          productsQuery = productsQuery.where(
            'customer',
            '==',
            this.searchCustomer.toLowerCase()
          );
          procurementQuery = procurementQuery.where(
            'customer',
            '==',
            this.searchCustomer.toLowerCase()
          );
        }
        if (this.searchJobNum.value != null && this.searchJobNum.value != '') {
          query = query.where('jobNum', '==', Number(this.searchJobNum.value));
          productsQuery = productsQuery.where(
            'jobNum',
            '==',
            Number(this.searchJobNum.value)
          );
          procurementQuery = procurementQuery.where(
            'jobNum',
            '==',
            Number(this.searchJobNum.value)
          );
        }
        if (this.searchStartDate != null && this.searchStartDate != '') {
          query = query.where('date', '>=', this.searchStartDate);
          productsQuery = productsQuery.where(
            'date',
            '>=',
            this.searchStartDate
          );
          procurementQuery = procurementQuery.where(
            'date',
            '>=',
            this.searchStartDate
          );
        }
        if (this.searchEndDate != null && this.searchEndDate != '') {
          this.searchEndDate = new Date(
            moment(this.searchEndDate).endOf('day')
          );
          query = query.where('date', '<=', this.searchEndDate);
          productsQuery = productsQuery.where('date', '<=', this.searchEndDate);
          procurementQuery = procurementQuery.where(
            'date',
            '<=',
            this.searchEndDate
          );
        }
        if (this.searchProduct != null && this.searchProduct != '') {
          productsQuery = productsQuery.where(
            'products',
            '==',
            this.searchProduct
          );
        }

        if(this.selectedTimeApprovalFilter === 'approved'){
          query = query.where('approved', '==', true)
        }
        else if(this.selectedTimeApprovalFilter === 'unapproved'){
          query = query.where('approved', '==', false)
        }

        //logical processor for dispalying the chart
        if (this.searchCustomer != null && this.customer != '') {
          this.chart2Visible = false;
        } else {
          this.chart2Visible = true;
        }
        if (this.searchJobNum.value != null && this.searchJobNum.value != '') {
          this.chart1Visible = false;
        } else {
          this.chart1Visible = true;
        }

        //get the selected times.
        await query
          .orderBy('date', 'asc')
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              console.log('No records returned.');
            }
            let currentDate;
            let currentDate2;
            querySnapshot.forEach((doc) => {
              //find the employee data for the time that we are iterating.

              let tempEmployee = this.allEmployees.find(
                (o) => o.uid == doc.data().user
              );

              if (tempEmployee) {
                let payrollRate =
                  tempEmployee.payrollRate != undefined
                    ? Number(tempEmployee.payrollRate)
                    : 0;
                //check to see what time this is, so we can put the correct payroll rate.
                if (doc.data().overtime) {
                  payrollRate =
                    tempEmployee.payrollOvertimeRate != undefined
                      ? Number(tempEmployee.payrollOvertimeRate)
                      : tempEmployee.payrollRate;
                } else if (doc.data().travelTime) {
                  payrollRate =
                    tempEmployee.travelRate != undefined
                      ? Number(tempEmployee.travelRate)
                      : tempEmployee.payrollRate;
                }
                let newTime = {
                  id: doc.id,
                  approved: doc.data().approved,
                  approvedBy: doc.data().approvedBy,
                  approvedTime: doc.data().approvedTime,
                  Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                  Employee: doc.data().employee,
                  Description: doc.data().description,
                  Hours: doc.data().hours,
                  Type: doc.data().overtime
                    ? 'ot'
                    : doc.data().travelTime
                    ? 'tt'
                    : 'reg',
                  Rate: doc.data().rate,
                  Job: doc.data().jobNum,
                  Customer: doc.data().customer,
                  PayrollRate: payrollRate,
                  Billable: doc.data().billable ? false : true, //this logic is backwards. true is excluded from billing // Updated 8/31/2023 - logic corrected
                };

                if (tempEmployee.deactivated) {
                  this.allEmployeesTableData.push(newTime);
                } else {
                  this.allEmployeesTableData.push(newTime);
                  this.tableData.push(newTime);
                  this.altTableData.push(newTime);
                }
                //calculate report totals for all employees and for only active employees

                //active employees
                if (!tempEmployee.deactivated) {
                  if (
                    currentDate !=
                    moment(doc.data().date.toDate()).format('MMM DD, YY')
                  ) {
                    this.reportTotals[1].value = (
                      Number(this.reportTotals[1].value) + 1
                    ).toString();
                    hoursWorkedDays.categories.push(
                      moment(doc.data().date.toDate()).format('MMM DD, YY')
                    );
                    hoursWorkedData[0].data.push(Number(doc.data().hours));
                  } else {
                    hoursWorkedData[0].data[
                      hoursWorkedData[0].data.length - 1
                    ] =
                      hoursWorkedData[0].data[
                        hoursWorkedData[0].data.length - 1
                      ] + Number(doc.data().hours);
                  }

                  //start adding name to the labels for the pie chart.
                  if (!hoursWorkedCustomer.includes(doc.data().customer)) {
                    if (doc.data().customer != undefined) {
                      hoursWorkedCustomer.push(doc.data().customer);
                    }
                  }

                  if (!hoursWorkedJob.includes(doc.data().jobNum)) {
                    hoursWorkedJob.push(doc.data().jobNum);
                  }

                  currentDate = moment(doc.data().date.toDate()).format(
                    'MMM DD, YY'
                  );
                  this.reportTotals[0].value = (
                    Number(this.reportTotals[0].value) +
                    Number(doc.data().hours)
                  )
                    .toFixed(2)
                    .toString();
                  if (doc.data().overtime || doc.data().travelTime) {
                    if (doc.data().overtime) {
                      //add the cost to the overtime total.
                      this.reportTotals[3].value = (
                        Number(this.reportTotals[3].value) +
                        Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();

                      //only add the revenue if the time is billable.
                      if (doc.data().billable != true) {
                        this.reportTotals[5].value = (
                          Number(this.reportTotals[5].value) +
                          Number(doc.data().rate) * Number(doc.data().hours)
                        )
                          .toFixed(2)
                          .toString();
                      }

                      this.reportTotals[6].value = (
                        Number(this.reportTotals[6].value) +
                        Number(tempEmployee.payrollOvertimeRate) *
                          Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();
                    }
                    if (doc.data().travelTime) {
                      //add the cost tot he travel time total.
                      this.reportTotals[4].value = (
                        Number(this.reportTotals[4].value) +
                        Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();

                      //only add the revenue if the time is billable.
                      if (doc.data().billable != true) {
                        this.reportTotals[5].value = (
                          Number(this.reportTotals[5].value) +
                          Number(doc.data().rate) * Number(doc.data().hours)
                        )
                          .toFixed(2)
                          .toString();
                      }

                      //check to see if the user has an overtime rate set.

                      this.reportTotals[6].value = (
                        Number(this.reportTotals[6].value) +
                        (tempEmployee.travelRate != undefined
                          ? Number(tempEmployee.travelRate)
                          : Number(tempEmployee.payrollRate)) *
                          Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();
                    }
                  } else {
                    this.reportTotals[2].value = (
                      Number(this.reportTotals[2].value) +
                      Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();

                    //only add the revenue if the time is billable.
                    if (doc.data().billable != true) {
                      this.reportTotals[5].value = (
                        Number(this.reportTotals[5].value) +
                        Number(doc.data().rate) * Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();
                    }

                    this.reportTotals[6].value = (
                      Number(this.reportTotals[6].value) +
                      Number(tempEmployee.payrollRate) *
                        Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();
                  }
                  //add the hours for the customer and job.
                  let customerIndex = hoursWorkedCustomer.indexOf(
                    doc.data().customer
                  ); //customer
                  hoursWorkedCustomerData[customerIndex] =
                    (hoursWorkedCustomerData[customerIndex] == undefined
                      ? 0
                      : hoursWorkedCustomerData[customerIndex]) +
                    Number(doc.data().hours); //hoursWorkedCustomerData[customerIndex] +
                  let jobIndex = hoursWorkedJob.indexOf(doc.data().jobNum); //job
                  hoursWorkedJobData[jobIndex] =
                    (hoursWorkedJobData[jobIndex] == undefined
                      ? 0
                      : hoursWorkedJobData[jobIndex]) +
                    Number(doc.data().hours); //hoursWorkedJobData[jobIndex] +
                }

                //all employees
                if (
                  currentDate2 !==
                  moment(doc.data().date.toDate()).format('MMM DD, YY')
                ) {
                  this.allEmployeesReportTotals[1].value = (
                    Number(this.allEmployeesReportTotals[1].value) + 1
                  ).toString();
                  allEmployeesHoursWorkedDays.categories.push(
                    moment(doc.data().date.toDate()).format('MMM DD, YY')
                  );
                  allEmployeesHoursWorkedData[0].data.push(
                    Number(doc.data().hours)
                  );
                } else {
                  allEmployeesHoursWorkedData[0].data[
                    allEmployeesHoursWorkedData[0].data.length - 1
                  ] =
                    allEmployeesHoursWorkedData[0].data[
                      allEmployeesHoursWorkedData[0].data.length - 1
                    ] + Number(doc.data().hours);
                }

                //start adding name to the labels for the pie chart.
                if (
                  !allEmployeesHoursWorkedCustomer.includes(doc.data().customer)
                ) {
                  if (doc.data().customer != undefined) {
                    allEmployeesHoursWorkedCustomer.push(doc.data().customer);
                  }
                }

                if (!allEmployeesHoursWorkedJob.includes(doc.data().jobNum)) {
                  allEmployeesHoursWorkedJob.push(doc.data().jobNum);
                }

                currentDate2 = moment(doc.data().date.toDate()).format(
                  'MMM DD, YY'
                );
                this.allEmployeesReportTotals[0].value = (
                  Number(this.allEmployeesReportTotals[0].value) +
                  Number(doc.data().hours)
                )
                  .toFixed(2)
                  .toString();
                if (doc.data().overtime || doc.data().travelTime) {
                  if (doc.data().overtime) {
                    //add the cost to the overtime total.
                    this.allEmployeesReportTotals[3].value = (
                      Number(this.allEmployeesReportTotals[3].value) +
                      Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();

                    //only add the revenue if the time is billable.
                    if (doc.data().billable != true) {
                      this.allEmployeesReportTotals[5].value = (
                        Number(this.allEmployeesReportTotals[5].value) +
                        Number(doc.data().rate) * Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();
                    }

                    this.allEmployeesReportTotals[6].value = (
                      Number(this.allEmployeesReportTotals[6].value) +
                      Number(tempEmployee.payrollOvertimeRate) *
                        Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();
                  }
                  if (doc.data().travelTime) {
                    //add the cost tot he travel time total.
                    this.allEmployeesReportTotals[4].value = (
                      Number(this.allEmployeesReportTotals[4].value) +
                      Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();

                    //only add the revenue if the time is billable.
                    if (doc.data().billable != true) {
                      this.allEmployeesReportTotals[5].value = (
                        Number(this.allEmployeesReportTotals[5].value) +
                        Number(doc.data().rate) * Number(doc.data().hours)
                      )
                        .toFixed(2)
                        .toString();
                    }

                    //check to see if the user has an overtime rate set.

                    this.allEmployeesReportTotals[6].value = (
                      Number(this.allEmployeesReportTotals[6].value) +
                      (tempEmployee.travelRate != undefined
                        ? Number(tempEmployee.travelRate)
                        : Number(tempEmployee.payrollRate)) *
                        Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();
                  }
                } else {
                  this.allEmployeesReportTotals[2].value = (
                    Number(this.allEmployeesReportTotals[2].value) +
                    Number(doc.data().hours)
                  )
                    .toFixed(2)
                    .toString();
                  //only add the revenue if the time is billable.
                  if (doc.data().billable != true) {
                    this.allEmployeesReportTotals[5].value = (
                      Number(this.allEmployeesReportTotals[5].value) +
                      Number(doc.data().rate) * Number(doc.data().hours)
                    )
                      .toFixed(2)
                      .toString();
                  }

                  this.allEmployeesReportTotals[6].value = (
                    Number(this.allEmployeesReportTotals[6].value) +
                    Number(tempEmployee.payrollRate) * Number(doc.data().hours)
                  )
                    .toFixed(2)
                    .toString();
                }
                //add the hours for the customer and job.
                let customerIndex = allEmployeesHoursWorkedCustomer.indexOf(
                  doc.data().customer
                ); //customer
                allEmployeesHoursWorkedCustomerData[customerIndex] =
                  (allEmployeesHoursWorkedCustomerData[customerIndex] ==
                  undefined
                    ? 0
                    : allEmployeesHoursWorkedCustomerData[customerIndex]) +
                  Number(doc.data().hours); //hoursWorkedCustomerData[customerIndex] +
                let jobIndex = allEmployeesHoursWorkedJob.indexOf(
                  doc.data().jobNum
                ); //job
                allEmployeesHoursWorkedJobData[jobIndex] =
                  (allEmployeesHoursWorkedJobData[jobIndex] == undefined
                    ? 0
                    : allEmployeesHoursWorkedJobData[jobIndex]) +
                  Number(doc.data().hours); //hoursWorkedJobData[jobIndex] +
              }
            });

            //set the chart data for active employees.
            this.hoursByDays.series = hoursWorkedData;
            this.hoursByCustomer.series = hoursWorkedCustomerData;
            this.hoursByJob.series = hoursWorkedJobData;
            //this ... notation takes all of the data that is in the object and we can just set one specific nessted object within it. Like so... (get it... ha!)
            this.hoursByDays.chartOptions = {
              ...this.hoursByDays.chartOptions,
              ...{
                xaxis: hoursWorkedDays,
              },
            };
            this.hoursByCustomer.chartOptions = {
              ...this.hoursByCustomer.chartOptions,
              ...{
                labels: hoursWorkedCustomer,
              },
            };
            this.hoursByJob.chartOptions = {
              ...this.hoursByJob.chartOptions,
              ...{
                labels: hoursWorkedJob,
              },
            };

            //set the chart data for all employees.
            this.allEmployeesHoursByDays.series = allEmployeesHoursWorkedData;
            this.allEmployeesHoursByCustomer.series =
              allEmployeesHoursWorkedCustomerData;
            this.allEmployeesHoursByJob.series = allEmployeesHoursWorkedJobData;
            //this ... notation takes all of the data that is in the object and we can just set one specific nessted object within it. Like so... (get it... ha!)
            this.allEmployeesHoursByDays.chartOptions = {
              ...this.allEmployeesHoursByDays.chartOptions,
              ...{
                xaxis: allEmployeesHoursWorkedDays,
              },
            };
            this.allEmployeesHoursByCustomer.chartOptions = {
              ...this.allEmployeesHoursByCustomer.chartOptions,
              ...{
                labels: allEmployeesHoursWorkedCustomer,
              },
            };
            this.allEmployeesHoursByJob.chartOptions = {
              ...this.allEmployeesHoursByJob.chartOptions,
              ...{
                labels: allEmployeesHoursWorkedJob,
              },
            };
          })
          .catch((err) => {
            console.log(err);
            Vue.$toast.open({
              message: `Error getting report data: ${err}`,
              type: 'error',
              duration: 4000,
              position: 'top-right',
            });
          });

        //get the selected products
        await productsQuery
          .orderBy('date', 'asc')
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              console.log('No product records returned.');
            }
            let currentDate;
            querySnapshot.forEach((doc) => {
              let newProduct = {
                id: doc.id,
                Approved: doc.data().approved,
                Date: moment(doc.data().date.toDate()).format('MMM DD, YY'),
                Employee: doc.data().user.name,
                Product: doc.data().products,
                Quantity: doc.data().quantity,
                Rate: doc.data().rate,
                Job: doc.data().jobNum,
                Customer: doc.data().customer,
                PurchasePrice: doc.data().price ? doc.data().price : 0,
                Billable: doc.data().billable ? !doc.data().billable : true,
                ApprovedTime: doc.data().approvedTime,
                ApprovedBy: doc.data().approvedBy
              };

              this.productsTableData.push(newProduct);

              if (
                currentDate !=
                moment(doc.data().date.toDate()).format('MMM DD, YY')
              ) {
                this.productReportTotals[1].value = (
                  Number(this.productReportTotals[1].value) + 1
                ).toString();
                productsDays.categories.push(
                  moment(doc.data().date.toDate()).format('MMM DD, YY')
                );
                productsData[0].data.push(Number(doc.data().quantity));
              } else {
                productsData[0].data[productsData[0].data.length - 1] =
                  productsData[0].data[productsData[0].data.length - 1] +
                  Number(doc.data().quantity);
              }

              //start adding name to the labels for the pie chart.
              if (!productsCustomer.includes(doc.data().customer)) {
                if (doc.data().customer != undefined) {
                  productsCustomer.push(doc.data().customer);
                }
              }

              if (!productsJob.includes(doc.data().jobNum)) {
                productsJob.push(doc.data().jobNum);
              }

              currentDate = moment(doc.data().date.toDate()).format(
                'MMM DD, YY'
              );
              this.productReportTotals[0].value = (
                Number(this.productReportTotals[0].value) +
                Number(doc.data().quantity)
              )
                .toFixed(2)
                .toString();

              if (doc.data().billable != true) {
                this.productReportTotals[2].value = (
                  Number(this.productReportTotals[2].value) +
                  Number(doc.data().quantity) * Number(doc.data().rate)
                )
                  .toFixed(2)
                  .toString();
              }

              this.productReportTotals[3].value = (
                Number(this.productReportTotals[3].value) +
                Number(doc.data().quantity) *
                  Number(doc.data().price ? doc.data().price : 0)
              )
                .toFixed(2)
                .toString();
              //add the hours for the customer and job.
              let customerIndex = productsCustomer.indexOf(doc.data().customer); //customer
              productsCustomerData[customerIndex] =
                (productsCustomerData[customerIndex] == undefined
                  ? 0
                  : productsCustomerData[customerIndex]) +
                Number(doc.data().quantity);
              let jobIndex = productsJob.indexOf(doc.data().jobNum); //job
              productsJobData[jobIndex] =
                (productsJobData[jobIndex] == undefined
                  ? 0
                  : productsJobData[jobIndex]) + Number(doc.data().quantity);
            });

            //set the chart data.
            this.productsByDays.series = productsData;
            this.productsByCustomer.series = productsCustomerData;
            this.productsByJob.series = productsJobData;
            //this ... notation takes all of the data that is in the object and we can just set one specific nessted object within it. Like so... (get it... ha!)
            this.productsByDays.chartOptions = {
              ...this.productsByDays.chartOptions,
              ...{
                xaxis: productsDays,
              },
            };
            this.productsByCustomer.chartOptions = {
              ...this.productsByCustomer.chartOptions,
              ...{
                labels: productsCustomer,
              },
            };
            this.productsByJob.chartOptions = {
              ...this.productsByJob.chartOptions,
              ...{
                labels: productsJob,
              },
            };
          })
          .catch((err) => {
            console.log(err);
          });

        //get the selected procurements if the product or customer or employee is not selected
        if (
          (this.searchEmployee === null || this.searchEmployee === '') &&
          (this.searchProduct === null || this.searchProduct === '')
        ) {
          await procurementQuery
            .orderBy('date', 'asc')
            .get()
            .then((querySnapshot) => {
              if (querySnapshot.empty) {
                console.log('No procurement records returned.');
              }
              querySnapshot.forEach((doc) => {
                let index = this.procurementTableData.push(doc.data());
                // this.tableData[index - 1]['edit'] = doc.id;
                this.changeTimeFormats(index - 1);
                this.totalQuotedAmount += Number(doc.data().quotedAmount);
                if (doc.data().receivedAmount) {
                  this.totalReceivedAmount += Number(doc.data().receivedAmount);
                }
                //only calculate if the procurement isn't set as non-billable.
                if (doc.data().billable.value != true) {
                  //calculate the revenue of the procurement.
                  if (doc.data().markupType === 'percentage') {
                    //the received amount times the percentage.
                    this.totalProcurementRevenue +=
                      Number(doc.data().receivedAmount) *
                      (Number(doc.data().markup) / 100 + 1);
                  } else if (doc.data().markupType === 'dollar') {
                    this.totalProcurementRevenue +=
                      Number(doc.data().receivedAmount) +
                      Number(doc.data().markup);
                  } else if (doc.data().markupType === 'flatRate') {
                    this.totalProcurementRevenue += Number(doc.data().markup);
                  } else {
                    //if there is no mark up set, we just use the received amount as the revenue amount.
                    this.totalProcurementRevenue += Number(
                      doc.data().receivedAmount
                    );
                  }
                }

                if (!doc.data().billable) {
                  this.procurementTableData[index - 1]['billable'] = {
                    name: null,
                    time: null,
                    uid: null,
                    value: false,
                  };
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
          this.procurementReportTotals[0].value =
            this.procurementTableData.length.toFixed(); //amount of procurements
          this.procurementReportTotals[1].value =
            this.totalReceivedAmount.toFixed(2); //procurement expense
          this.procurementReportTotals[2].value =
            this.totalProcurementRevenue.toFixed(2); //procurement revenue
          this.procurementReportTotals[3].value = (
            this.totalProcurementRevenue.toFixed(2) -
            this.totalReceivedAmount.toFixed(2)
          ).toFixed(2); //procurement profit

          // this.procurementReportTotals[1].value = this.totalQuotedAmount.toFixed(
          //   2
          // );
          // this.procurementReportTotals[2].value = this.totalReceivedAmount.toFixed(
          //   2
          // );

          // this.procurementReportTotals[3].value = Math.abs(
          //   this.totalQuotedAmount - this.totalReceivedAmount
          // ).toFixed(2);
          if (this.totalProcurementRevenue - this.totalReceivedAmount >= 0) {
            this.procurementReportTotals[3].color = 'green';
          } else {
            this.procurementReportTotals[3].color = 'red';
          }
        }
        this.reportLoading = false;
      } catch (err) {
        this.reportLoading = false;
        console.log(`Error getting report data: ${err}`);
        Vue.$toast.open({
          message: `Error getting report data: ${err}`,
          type: 'error',
          duration: 4000,
          position: 'top-right',
        });
      }

      // if (this.validateCreateReport()) {

      // }
    },
    changeTimeFormats(index) {
      this.procurementTableData[index].date =
        this.procurementTableData[index].date.toDate();
      if (this.procurementTableData[index].ordered.time) {
        this.procurementTableData[index].ordered.time =
          this.procurementTableData[index].ordered.time.toDate();
      }
      if (this.procurementTableData[index].received.time) {
        this.procurementTableData[index].received.time =
          this.procurementTableData[index].received.time.toDate();
      }
      if (this.procurementTableData[index].invoiced.time) {
        this.procurementTableData[index].invoiced.time =
          this.procurementTableData[index].invoiced.time.toDate();
      }
      if (this.procurementTableData[index].billable) {
        if (this.procurementTableData[index].billable.time) {
          this.procurementTableData[index].billable.time =
            this.procurementTableData[index].billable.time.toDate();
        }
      }
    },
    getInitialCustomers() {
      getCustomers()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.customers.push(doc.data().displayName);
          });
        })
        .catch(() => {
          console.log(`Error getting customers...`);
        });
    },
    // validateCreateReport: function() {
    //   let flag = true;
    //   //Employee not Selected
    //   if (this.searchEmployee == null) {
    //     this.createReport_errors.employeeError = true;
    //     this.createReport_errors.employeeMessage = 'Employee must be selected.';
    //     flag = false;
    //   } else {
    //     this.createReport_errors.employeeError = false;
    //     this.createReport_errors.employeeMessage = null;
    //   }

    //   return flag;
    // },
    getInitialEmployees() {
      getAllEmployees()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            if (doc.data().deactivatedDate === null) {
              this.employee.push({
                name: doc.data().displayName,
                uid: doc.id,
                payrollRate: doc.data().payrollRate
                  ? doc.data().payrollRate
                  : 0,
                payrollOvertimeRate: doc.data().payrollOvertimeRate
                  ? doc.data().payrollOvertimeRate
                  : 0,
                travelRate: doc.data().travelTimeRate
                  ? doc.data().travelTimeRate
                  : doc.data().payrollRate,
              });
            }
            this.allEmployees.push({
              name: doc.data().displayName,
              uid: doc.id,
              payrollRate: doc.data().payrollRate ? doc.data().payrollRate : 0,
              payrollOvertimeRate: doc.data().payrollOvertimeRate
                ? doc.data().payrollOvertimeRate
                : 0,
              travelRate: doc.data().travelTimeRate
                ? doc.data().travelTimeRate
                : doc.data().payrollRate,
              deactivated: doc.data().deactivatedDate ? true : false,
            });
          });
        })
        .catch(() => {
          console.log(`Error getting Employees...`);
        });
    },
    getInitialProducts() {
      getProducts()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            this.productNames.push(doc.data().displayName);
            this.products.push(doc.data());
          });
        })
        .catch((error) => {
          console.log(`Error getting Products... # ${error}`);
        });
    },
    getJobs() {
      this.jobs = [];
      getJobsFromCustomer(this.searchCustomer)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const jobData = doc.data();
            this.jobs.push({ value: jobData.jobNum, label: `${jobData.jobNum} - ${jobData.description}` });
          });
        })
        .catch((err) => {
          console.log(`Error getting job numbers from customer.`);
          console.log(err);
        });
    },
    approveTime: async function (value, id) {
      await this.$nextTick();
      try {
        let db = firebase.firestore();
        let page = db.collection('times').doc(id);
        let user = JSON.parse(sessionStorage.authUser);
        let approvedTime = Date.now();

        let index = this.tableData.findIndex((data) => data.id === id);
        let newData = JSON.parse(JSON.stringify(this.tableData[index]));
        newData.approved = value;
        newData.approvedTime = value ? Date(approvedTime) : null;
        newData.approvedBy = value
          ? { name: user.displayName, uid: user.uid }
          : null;

        await page
          .update({
            approved: newData.approved,
            approvedTime: newData.approvedTime,
            approvedBy: newData.approvedBy,
          })
          .then(() => {
            this.tableData.splice(index, 1, newData);
            Vue.$toast.open({
              message: value
                ? 'Time approved successfully'
                : 'Time unapproved successfully',
              type: 'success',
              duration: 4000,
              position: 'top-right',
            });
          })
          .catch(() => {
            console.log(`Error changing time approval status.`);
            Swal.fire(
              'Error!',
              'An error was encountered when changing the times approval status',
              'error'
            );
          });
      } catch (error) {
        console.log(error);
        Swal.fire('Error!', 'An error was encountered tu', 'error');
      }
    },
    approveBillableProduct: async function (time, item) {
      await this.$nextTick();
      try {
        let user = JSON.parse(sessionStorage.authUser);
        let index = this.productsTableData.findIndex((data) => data.id === item.id);
        let approvedTime = Date.now();

        firebase.firestore().collection('billableProducts').doc(item.id).update({
          approved: item.Approved,
          approvedTime: item.Approved ? Date(approvedTime) : null,
          approvedBy: item.Approved ? { name: user.displayName, uid: user.uid } : null
        })
        .then(() => {
          let newData = {
            id: item.id,
            Approved:  item.Approved,
            Date: item.Date,
            Employee: item.Employee,
            Product: item.Product,
            Quantity: item.Quantity,
            Rate: item.Rate,
            Job: item.Job,
            Customer: item.Customer,
            PurchasePrice: item.PurchasePrice,
            Billable: item.Billable,
            ApprovedTime: item.Approved ? moment(time).format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ') : null,
            ApprovedBy: item.Approved ? { name: user.displayName, uid: user.uid } : null
          };
          this.productsTableData.splice(index, 1, newData);
          Vue.$toast.open({
            message: item.Approved
            ? 'Product approved successfully'
            : 'Product unapproved successfully',
            type: 'success',
            duration: 4000,
            position: 'top-right',
          });
        })
        .catch(() => {
          console.log(`Error changing product approval status.`);
          Swal.fire(
            'Error!',
            'An error was encountered when changing the product approval status',
            'error'
          );
        });   
      }
      catch (err){
          console.log(err)
          Swal.fire('Error!', 'An error was encountered tu', 'error');

      }
    },
    handleApprovalChange(date, dataItem) {
      this.approveBillableProduct(date, dataItem)
  },
    setTableSettings: function () {
      this.currentUser = this.$store.state.custom.currentUserData;
      if (this.currentUser.tablePageLengths) {
        if (this.currentUser.tablePageLengths.perPage_costEarnings) {
          this.perPage = this.currentUser.tablePageLengths.perPage_costEarnings;
        }
      }
    },
    getJobNumFromString(timeData){
      const jobString = timeData;
      let jobNum;
      if(typeof jobString == 'string'){
      let wordArray = jobString.split(" ");
       jobNum = wordArray[0];
      }
      else{
        jobNum = jobString.toString().trim();
      }
      return jobNum;
    },
    updateJobCompleteStatus(jobDocID, jobCompleteStatus){
      //update the complete status of the job.
      try {
        firebase
          .firestore()
            .collection('jobs')
            .doc(jobDocID)
            .update({
              completed: !jobCompleteStatus,
            })
            .then(() => {
              // update local data
              let tableDataCopy = lodash.cloneDeep(this.tableData);
              let allEmployeesTableDataCopy = lodash.cloneDeep(this.allEmployeesTableData);
              // filter so we only have times associated with this specific jobDocID
              let tableDataJobTimes = tableDataCopy.filter((time) => time.JobDocID === jobDocID);
              let allEmployeesJobTimes = allEmployeesTableDataCopy.filter((time) => time.JobDocID === jobDocID);
              tableDataJobTimes.forEach((time) => {
                time.JobCompletedStatus = !jobCompleteStatus;
              });
              allEmployeesJobTimes.forEach((time) => {
                time.JobCompletedStatus = !jobCompleteStatus;
              });
              // because tableDataJobTimes filtered times array references tableDataCopy, we can just update this.tableData with tableDataCopy
              this.tableData = tableDataCopy;
              this.allEmployeesTableData = allEmployeesTableDataCopy;
              Vue.$toast.open({
                message: 'Job status updated',
                type: 'success',
                duration: 4000,
                position: 'top-right',
              });
            })
            .catch(() => {
              Swal.fire(
                'Error!',
                'Error updating the completed status of the job. (1)',
                'error'
              );
            });
      } catch (err) {
        Swal.fire(
          'Error!',
          'Error updating the completed status of the job. (2)',
          'error'
        );
      }
    },
    goToJob(jobNum){
      // pull the job number from the "job num - job description" string and push user to the job route
      this.$router.push(`/production/jobs/jobDetails/${this.getJobNumFromString(jobNum)}`);
    },
    tableSort: tableSort,
  },
  created: function () {
    this.getInitialCustomers();
    this.getInitialEmployees();
    this.getInitialProducts();
    this.setTableSettings();
  },
  watch: {
    async altTableData(newItems) {
      // go through tabledata when it is changed and get job description for each alttabledata item
      // then add jobDescription to each alttabledata item
      let array = [...newItems];
      let jobsMap = {};
      if (array.length > 0 && array.length !== undefined) {
        this.specificJob = [];

        for (let index = 0; index < array.length; index++) {
          let item = array[index];
          // limit db reads so it only gets unique Jobs by comparing to jobsMap
          if (jobsMap[item.Job] === undefined) {
            let query = firebase
              .firestore()
              .collection('jobs')
              .where('org', '==', sessionStorage.getItem('org'))
              .where('jobNum', '==', Number(item.Job));
            try {
              await query
                .get()
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    // add job and job description to map
                    jobsMap[item.Job] = {
                      description: doc.data().description, 
                      jobCompletedStatus: doc.data().completed ?? false,
                      jobDocID: doc.id
                    };
                    // update tabledata
                    let timeItem = array[index];
                    timeItem.Job = timeItem.Job + ` - ${doc.data().description}`;
                    timeItem.JobCompletedStatus = doc.data().completed ?? false;
                    timeItem.JobDocID = doc.id;
                  });
                })
                .catch((err) => {
                  console.log(err);
                  Vue.$toast.open({
                    message: `Error getting specific job from database.`,
                    duration: 4000,
                    position: 'top-right',
                    dismissible: true,
                    type: 'error',
                  });
                });
            } catch (err) {
              console.log(err);
              Vue.$toast.open({
                message: `Error adding job descriptions to the time table`,
                duration: 4000,
                position: 'top-right',
                dismissible: true,
                type: 'error',
              });
            }
          } else {
            // job info for this table data item has already been pulled from db so find it in map and use it
            // update tabledata
            let jobData = jobsMap[item.Job];
            let timeItem = array[index];
            timeItem.Job = timeItem.Job + ` - ${jobData.description}`;
            timeItem.JobCompletedStatus = jobData.jobCompletedStatus;
            timeItem.JobDocID = jobData.jobDocID;
          }
        }
        // reset altTableData so it doesn't build up when user generates more than one report in one session
        this.altTableData = [];
      }
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentUser = this.$store.state.custom.currentUserData;
        let currentUserDataCopy = JSON.parse(JSON.stringify(this.currentUser));
        let oldCurrentUserPerPage = null;

        if (currentUserDataCopy.tablePageLengths) {
          if(currentUserDataCopy.tablePageLengths.perPage_costEarnings){
            oldCurrentUserPerPage = currentUserDataCopy.tablePageLengths.perPage_costEarnings;
          }
          currentUserDataCopy.tablePageLengths['perPage_costEarnings'] = newVal;
        } else {
          currentUserDataCopy['tablePageLengths'] = {
            perPage_costEarnings: newVal,
          };
        }

        if (oldCurrentUserPerPage !== newVal) {
          firebase
            .firestore()
            .collection('employees')
            .doc(this.currentUser.auth)
            .update({
              tablePageLengths: currentUserDataCopy.tablePageLengths,
            });
        }
        this.currentUser = currentUserDataCopy;
        this.$store.dispatch('custom/updateUserData', currentUserDataCopy);
      }
    },
  }
};
</script>
